import { Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import Button from '../../../components/base/Button';

export default function ConsultingServices() {
  return (
    <div className="min-h-screen" dir="rtl">
      <Header />
      
      {/* Breadcrumb */}
      <div className="bg-gray-50 py-4">
        <div className="container mx-auto px-4">
          <nav className="flex items-center text-sm text-gray-600">
            <Link to="/" className="hover:text-[#E71B25] transition-colors">
              الرئيسية
            </Link>
            <i className="ri-arrow-left-s-line mx-2"></i>
            <Link to="/services" className="hover:text-[#E71B25] transition-colors">
              الخدمات
            </Link>
            <i className="ri-arrow-left-s-line mx-2"></i>
            <span className="text-[#595A5C] font-medium">الاستشارات</span>
          </nav>
        </div>
      </div>

      <main className="py-20">
        <div className="container mx-auto px-4">
          {/* Hero Section */}
          <div className="text-center mb-16">
            <h1 className="text-5xl font-bold text-[#595A5C] mb-6">الاستشارات المتخصصة</h1>
            <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
              نقدم استشارات متخصصة في دراسات الجدوى وإدارة المخاطر والعقود، 
              بالإضافة إلى استراتيجيات التوسع في القطاعات الصناعية واللوجستية والدفاعية
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 mb-20">
            {/* Service Image */}
            <div className="order-2 lg:order-1">
              <img
                src="https://public.readdy.ai/ai/img_res/0021ecad6750e057db27700f8cf467b5.jpg"
                alt="الاستشارات المتخصصة"
                className="w-full h-96 object-cover rounded-2xl shadow-lg"
              />
            </div>

            {/* Service Content */}
            <div className="order-1 lg:order-2">
              <h2 className="text-3xl font-bold text-[#595A5C] mb-8">نطاق خدماتنا</h2>
              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="w-6 h-6 bg-[#E71B25] rounded-full flex items-center justify-center ml-4 mt-1 flex-shrink-0">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#595A5C] mb-2">دراسات الجدوى الفنية والمالية</h3>
                    <p className="text-gray-600">تحليل شامل للمشاريع وتقييم الفرص الاستثمارية</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-6 h-6 bg-[#E71B25] rounded-full flex items-center justify-center ml-4 mt-1 flex-shrink-0">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#595A5C] mb-2">إدارة المخاطر والعقود</h3>
                    <p className="text-gray-600">تطوير استراتيجيات إدارة المخاطر ومراجعة العقود</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-6 h-6 bg-[#E71B25] rounded-full flex items-center justify-center ml-4 mt-1 flex-shrink-0">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#595A5C] mb-2">استراتيجيات التوسع الصناعي</h3>
                    <p className="text-gray-600">تطوير خطط التوسع والنمو في القطاعات الصناعية</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-6 h-6 bg-[#E71B25] rounded-full flex items-center justify-center ml-4 mt-1 flex-shrink-0">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#595A5C] mb-2">الحلول اللوجستية</h3>
                    <p className="text-gray-600">تحسين سلاسل التوريد والعمليات اللوجستية</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-6 h-6 bg-[#E71B25] rounded-full flex items-center justify-center ml-4 mt-1 flex-shrink-0">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#595A5C] mb-2">الاستشارات الدفاعية</h3>
                    <p className="text-gray-600">استشارات متخصصة في القطاع الدفاعي والأمني</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Methodology Section */}
          <div className="bg-gray-50 rounded-2xl p-12 mb-20">
            <h2 className="text-3xl font-bold text-[#595A5C] mb-8 text-center">منهجيتنا في الاستشارات</h2>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
              <div className="text-center">
                <div className="w-16 h-16 bg-[#E71B25] rounded-xl flex items-center justify-center mx-auto mb-4">
                  <span className="text-white text-xl font-bold">1</span>
                </div>
                <h3 className="font-semibold text-[#595A5C] mb-2">التحليل والتقييم</h3>
                <p className="text-gray-600">دراسة شاملة للوضع الحالي والتحديات</p>
              </div>
              
              <div className="text-center">
                <div className="w-16 h-16 bg-[#E71B25] rounded-xl flex items-center justify-center mx-auto mb-4">
                  <span className="text-white text-xl font-bold">2</span>
                </div>
                <h3 className="font-semibold text-[#595A5C] mb-2">التخطيط الاستراتيجي</h3>
                <p className="text-gray-600">وضع استراتيجيات وخطط عمل مفصلة</p>
              </div>
              
              <div className="text-center">
                <div className="w-16 h-16 bg-[#E71B25] rounded-xl flex items-center justify-center mx-auto mb-4">
                  <span className="text-white text-xl font-bold">3</span>
                </div>
                <h3 className="font-semibold text-[#595A5C] mb-2">التنفيذ والمتابعة</h3>
                <p className="text-gray-600">إشراف على التنفيذ ومتابعة النتائج</p>
              </div>
              
              <div className="text-center">
                <div className="w-16 h-16 bg-[#E71B25] rounded-xl flex items-center justify-center mx-auto mb-4">
                  <span className="text-white text-xl font-bold">4</span>
                </div>
                <h3 className="font-semibold text-[#595A5C] mb-2">التقييم والتطوير</h3>
                <p className="text-gray-600">تقييم النتائج وتطوير الحلول</p>
              </div>
            </div>
          </div>

          {/* Why Choose Us */}
          <div className="mb-20">
            <h2 className="text-3xl font-bold text-[#595A5C] mb-12 text-center">لماذا فيبا للتجارة؟</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="text-center bg-white p-8 rounded-2xl shadow-lg">
                <div className="w-20 h-20 bg-[#E71B25] rounded-2xl flex items-center justify-center mx-auto mb-6">
                  <i className="ri-brain-line text-white text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-[#595A5C] mb-4">خبرة عميقة</h3>
                <p className="text-gray-600">فريق من الخبراء والمستشارين بخبرة واسعة في مختلف القطاعات</p>
              </div>
              
              <div className="text-center bg-white p-8 rounded-2xl shadow-lg">
                <div className="w-20 h-20 bg-[#E71B25] rounded-2xl flex items-center justify-center mx-auto mb-6">
                  <i className="ri-focus-3-line text-white text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-[#595A5C] mb-4">حلول مخصصة</h3>
                <p className="text-gray-600">استشارات مخصصة تماماً لاحتياجات وظروف كل عميل</p>
              </div>
              
              <div className="text-center bg-white p-8 rounded-2xl shadow-lg">
                <div className="w-20 h-20 bg-[#E71B25] rounded-2xl flex items-center justify-center mx-auto mb-6">
                  <i className="ri-line-chart-line text-white text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-[#595A5C] mb-4">نتائج قابلة للقياس</h3>
                <p className="text-gray-600">التركيز على تحقيق نتائج ملموسة وقابلة للقياس</p>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="text-center bg-[#E71B25] text-white p-12 rounded-2xl">
            <h2 className="text-3xl font-bold mb-6">تحتاج استشارة متخصصة؟</h2>
            <p className="text-xl mb-8 opacity-90">
              تواصل معنا اليوم للحصول على استشارة مجانية ومناقشة احتياجاتك الاستشارية
            </p>
            <Button 
              variant="outline" 
              size="lg" 
              className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-[#E71B25] whitespace-nowrap"
              onClick={() => window.location.href = 'mailto:info@vipatradingco.com'}
            >
              طلب عرض سعر
              <i className="ri-mail-line mr-2"></i>
            </Button>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}